// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DoorControl.css */
.door-control-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
}

.door-control-card {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 500px;
  text-align: center;
}

.door-control-card h1 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.8em;
  color: #333;
}

.message-text {
  white-space: pre-wrap;
  margin: 15px 0;
  font-size: 1em;
  color: #555;
  line-height: 1.6;
}

.photo-container {
  margin: 20px 0;
}

.instruction-image {
  max-width: 300px;
  max-height: 300px;
  margin: 10px auto;
  display: block;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.status-image {
  max-width: 100%;
  height: auto;
  margin: 15px auto;
  display: block;
  border-radius: 4px;
}

.buttons-container {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.door-button {
  padding: 10px 20px;
  font-size: 1em;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.door-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  color: #666;
}

/* New Styled Buttons with Icons */
.styled-button {
  background-color: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.styled-button:hover:not(:disabled) {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.styled-button.next-button {
  background-color: #28a745; /* Green for Next */
}

.styled-button.next-button:hover:not(:disabled) {
  background-color: #1e7e34;
}

.styled-button.open-button {
  background-color: #dc3545; /* Red for Open */
}

.styled-button.open-button:hover:not(:disabled) {
  background-color: #c82333;
}

.error-message {
  color: #dc3545; /* Red for errors */
  margin-top: 15px;
  font-weight: bold;
}

.success-message {
  color: #28a745; /* Green for success */
  margin-top: 15px;
  font-weight: bold;
}

.loading-text {
  text-align: center;
  margin-top: 15px;
  color: #555;
}

`, "",{"version":3,"sources":["webpack://./src/styles/DoorControl.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4DAA4D;EAC5D,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* DoorControl.css */\n.door-control-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f0f2f5;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.door-control-card {\n  background-color: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 500px;\n  text-align: center;\n}\n\n.door-control-card h1 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 1.8em;\n  color: #333;\n}\n\n.message-text {\n  white-space: pre-wrap;\n  margin: 15px 0;\n  font-size: 1em;\n  color: #555;\n  line-height: 1.6;\n}\n\n.photo-container {\n  margin: 20px 0;\n}\n\n.instruction-image {\n  max-width: 300px;\n  max-height: 300px;\n  margin: 10px auto;\n  display: block;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.status-image {\n  max-width: 100%;\n  height: auto;\n  margin: 15px auto;\n  display: block;\n  border-radius: 4px;\n}\n\n.buttons-container {\n  margin-top: 25px;\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n}\n\n.door-button {\n  padding: 10px 20px;\n  font-size: 1em;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n}\n\n.door-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  color: #666;\n}\n\n/* New Styled Buttons with Icons */\n.styled-button {\n  background-color: #007bff;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.styled-button:hover:not(:disabled) {\n  background-color: #0056b3;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.styled-button.next-button {\n  background-color: #28a745; /* Green for Next */\n}\n\n.styled-button.next-button:hover:not(:disabled) {\n  background-color: #1e7e34;\n}\n\n.styled-button.open-button {\n  background-color: #dc3545; /* Red for Open */\n}\n\n.styled-button.open-button:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.error-message {\n  color: #dc3545; /* Red for errors */\n  margin-top: 15px;\n  font-weight: bold;\n}\n\n.success-message {\n  color: #28a745; /* Green for success */\n  margin-top: 15px;\n  font-weight: bold;\n}\n\n.loading-text {\n  text-align: center;\n  margin-top: 15px;\n  color: #555;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
